import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

import PodcasterImpersonateSection from "./PodcasterImpersonateSection";
import ListenerActivityTab from "./ListenerActivityTab";
import ListenerNotificationsTab from "./ListenerNotificationsTab";

const UserEditModal = ({
    selected, label, form, onChangeForm, onSave, onClose, saving,
    onImpersonate, impersonating,
    activeTab, onChangeActiveTab, listenerClubs, clubsLoading,
    testContent, onChangeTestContent, onSendTestEmail, onSendTestNotification, sendingEmail, sendingNotif,
}) => (
    <Modal show={!!selected} onHide={onClose} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Edit {label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row className="g-3">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>First name</Form.Label>
                        <Form.Control value={form.first_name ?? ''} onChange={e => onChangeForm(f => ({ ...f, first_name: e.target.value }))} />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Last name</Form.Label>
                        <Form.Control value={form.last_name ?? ''} onChange={e => onChangeForm(f => ({ ...f, last_name: e.target.value }))} />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" value={form.email ?? ''} onChange={e => onChangeForm(f => ({ ...f, email: e.target.value }))} />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Subscription type</Form.Label>
                        <Form.Control value={form.subscription_type ?? ''} onChange={e => onChangeForm(f => ({ ...f, subscription_type: e.target.value }))} />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label>Contact info</Form.Label>
                        <Form.Control value={form.contact_info ?? ''} onChange={e => onChangeForm(f => ({ ...f, contact_info: e.target.value }))} />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Check
                        type="switch"
                        label="Account activated"
                        checked={!!form.activated}
                        onChange={e => onChangeForm(f => ({ ...f, activated: e.target.checked }))}
                    />
                </Col>

                {label === 'Podcaster' && (
                    <PodcasterImpersonateSection onImpersonate={onImpersonate} impersonating={impersonating} />
                )}

                {label === 'Listener' && (
                    <>
                        <Col md={12}><hr className="my-1" /></Col>
                        <Col md={12}>
                            <Nav variant="tabs" activeKey={activeTab} onSelect={onChangeActiveTab} className="mb-3">
                                <Nav.Item><Nav.Link eventKey="activity">Listener Activity</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link eventKey="notifications">Notifications</Nav.Link></Nav.Item>
                            </Nav>

                            {activeTab === 'activity' && (
                                <ListenerActivityTab clubs={listenerClubs} loading={clubsLoading} />
                            )}

                            {activeTab === 'notifications' && (
                                <ListenerNotificationsTab
                                    testContent={testContent}
                                    onChangeTestContent={onChangeTestContent}
                                    onSendEmail={onSendTestEmail}
                                    onSendNotification={onSendTestNotification}
                                    sendingEmail={sendingEmail}
                                    sendingNotif={sendingNotif}
                                />
                            )}
                        </Col>
                    </>
                )}
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-secondary" onClick={onClose} disabled={saving}>Cancel</Button>
            <Button variant="primary" onClick={onSave} disabled={saving}>
                {saving ? <><Spinner size="sm" animation="border" className="me-2" />Saving…</> : 'Save'}
            </Button>
        </Modal.Footer>
    </Modal>
);

export default UserEditModal;
